import React, { useMemo } from 'react';
import { PageTabs } from '@colonist/ui-platform';
import IconGameModeBase from '@static/images/game_mode_icons/base.svg';
import IconGameModeClassic1v1 from '@static/images/icon_gamemode_1v1.svg';
import IconGameModeCnK from '@static/images/game_mode_icons/cities_and_knights.svg';
import IconGameModeRush from '@static/images/game_mode_icons/colonist_rush_ranked.svg';
import { RankedModeId } from '../types.ts';
const allRankedModeDefs = [
    {
        id: RankedModeId.Classic4P,
        labelKey: 'strings:leaderboardPage.gameModes.baseGame',
        icon: IconGameModeBase
    },
    {
        id: RankedModeId.Classic1v1,
        labelKey: 'strings:leaderboardPage.gameModes.1v1',
        icon: IconGameModeClassic1v1
    },
    {
        id: RankedModeId.CitiesAndKnights4P,
        labelKey: 'strings:leaderboardPage.gameModes.citiesAndKnights',
        icon: IconGameModeCnK
    },
    {
        id: RankedModeId.Rush4P,
        labelKey: 'strings:leaderboardPage.gameModes.rush',
        icon: IconGameModeRush
    }
];
const useRankedModeTabs = (modeIds)=>useMemo(()=>{
        const modeIdSet = new Set(modeIds);
        return allRankedModeDefs.map((mode)=>({
                id: mode.id,
                label: {
                    key: mode.labelKey
                },
                icon: mode.icon,
                disabled: !modeIdSet.has(mode.id)
            }));
    }, [
        modeIds
    ]);
export const RankedModeSelector = ({ activeModeId, modeIds, onModeChange, direction, hideText })=>{
    const tabs = useRankedModeTabs(modeIds);
    return /*#__PURE__*/ React.createElement(PageTabs, {
        activeTabId: activeModeId,
        tabs: tabs,
        onTabChange: (tabId)=>onModeChange(tabId),
        direction: direction,
        hideText: hideText
    });
};
